import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-orgao-rg',
  templateUrl: './text-orgao-rg.component.html',
  styleUrls: ['./text-orgao-rg.component.scss'],
  viewProviders: [ParentFormGroup ]
})
export class TextOrgaoRgComponent implements OnInit {

  
  @ViewChild("sgOrgaoRg", { static: false }) sgOrgaoRg: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    (this.sgOrgaoRg.nativeElement as HTMLElement).addEventListener("input", this._limparCaracteres);
  }

  private _limparCaracteres(event){
    event.currentTarget.value = event.currentTarget.value.toUpperCase().replace(/[^A-zÀ-ú ]/g, '');
  } 
}
